<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="merge-germplasm.inventory-lots.title"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<span jhiTranslate="merge-germplasm.inventory-lots.description"></span>
	<br/><br/>
	<div *ngIf="gidsWithLots && gidsWithLots.length > 0">
		<div class="card">
			<h5 class="card-header"><span jhiTranslate="merge-germplasm.action.apply.to.all.description"></span></h5>
			<div class="card-body">
				<div class="mb-3 row">
					<div class="col">
						<div class="form-check form-check-inline">
							<input type="radio" class="form-check-input" name="applyToAll" id="radioCloseAllLots"
								   [(ngModel)]="applyToAll" [value]="lotMergeOptionsEnum.CLOSE" (change)="applyToAllNonSelectedGermplasm()">
							<label class="form-check-label" for="radioCloseAllLots" jhiTranslate="merge-germplasm.action.apply.to.all.closeLots">
							</label>
						</div>
						<br/>
						<div class="form-check form-check-inline">
							<input type="radio" class="form-check-input" name="applyToAll" id="radioMigrateAllLots"
								   [(ngModel)]="applyToAll" [value]="lotMergeOptionsEnum.MIGRATE" (change)="applyToAllNonSelectedGermplasm()">
							<label class="form-check-label" for="radioMigrateAllLots" jhiTranslate="merge-germplasm.action.apply.to.all.associateLots">
							</label>
						</div>
						<br/>
						<div class="form-check form-check-inline">
							<input type="radio" class="form-check-input" name="applyToAll" id="radioOmitAllLots"
								   [(ngModel)]="applyToAll" [value]="lotMergeOptionsEnum.OMIT" (change)="applyToAllNonSelectedGermplasm()">
							<label class="form-check-label" for="radioOmitAllLots" jhiTranslate="merge-germplasm.action.apply.to.all.omitLots">
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-curved mt-3">
				<thead>
				<tr>
					<th><span jhiTranslate="merge-germplasm.action.omit.germplasm"></span></th>
					<th><span jhiTranslate="search-germplasm.column.gid"></span></th>
					<th><span jhiTranslate="merge-germplasm.column.designation"></span></th>
					<th><span jhiTranslate="search-germplasm.column.lotCount"></span></th>
					<th><span jhiTranslate="merge-germplasm.action.lot.options"></span></th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let nonSelected of germplasmMergeRequest.nonSelectedGermplasm">
					<td>
						<div class="form-check form-check-inline">
							<input type="checkbox" class="form-check-input" [name]="'migrateLotsOption' + nonSelected.germplasmId" [attr.id]="'radioOmit' + nonSelected.germplasmId"
							   [(ngModel)]="nonSelected.omit">
						</div>
					</td>
					<td><a class="link" [href]="germplasmDetailsUrlService.getUrl(nonSelected.germplasmId)" target="_blank">{{nonSelected.germplasmId}}</a></td>
					<td>{{nonSelected.germplasm.germplasmPreferredName}}</td>
					<td><a *ngIf="nonSelected.germplasm.lotCount" (click)="$event.stopPropagation(); inventoryDetailsPopupService.open(nonSelected.germplasmId)">{{nonSelected.germplasm.lotCount}}</a>
					</td>
					<td>
						<div class="form-check form-check-inline">
							<input type="radio" class="form-check-input" [name]="'migrateLotsOption' + nonSelected.germplasmId" [attr.id]="'radioCloseLots' + nonSelected.germplasmId"
								   [(ngModel)]="nonSelected.migrateLots" [value]="false">
							<label class="form-check-label" [attr.for]="'radioCloseLots' + nonSelected.germplasmId" jhiTranslate="merge-germplasm.action.closeLots">
							</label>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<input type="radio" class="form-check-input" [name]="'migrateLotsOption' + nonSelected.germplasmId" [attr.id]="'radioAssociateLots' + nonSelected.germplasmId"
								   [(ngModel)]="nonSelected.migrateLots" [value]="true">
							<label class="form-check-label" [attr.for]="'radioAssociateLots' + nonSelected.germplasmId" jhiTranslate="merge-germplasm.action.associateLots">
							</label>
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="confirm()" class="btn btn-primary">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;
		<span jhiTranslate="merge-germplasm.confirm"></span>
	</button>
</div>
